import { AlertIcon } from './icons';

export function Banner({ messages }: { messages: string[] }) {
  if (!messages.length) return null;
  return (
    <div className="cbf-banner" role="alert">
      <AlertIcon size={20} />
      <div>
        {messages.map((m, i) => (
          <div key={i}>{m}</div>
        ))}
      </div>
    </div>
  );
}
